import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";
//?  English Version
import createGroupInstruction1 from "../../assets/img/tutorialimages/addMemberGuide1.png";
import createGroupInstruction2 from "../../assets/img/tutorialimages/addMemberGuide2.png";
import createGroupInstruction3 from "../../assets/img/tutorialimages/addMemberGuide3.png";
import createGroupInstruction4 from "../../assets/img/tutorialimages/addMemberGuide4.png";

//? Japanese Version
import createGroupInstruction1Jap from "../../assets/img/tutorialimages/addMemberGuide1_Jap.png";
import createGroupInstruction2Jap from "../../assets/img/tutorialimages/addMemberGuide2_Jap.png";
import createGroupInstruction3Jap from "../../assets/img/tutorialimages/addMemberGuide3_Jap.png";
import createGroupInstruction4Jap from "../../assets/img/tutorialimages/addMemberGuide4_Jap.png";
import createGroupInstruction5Jap from "../../assets/img/tutorialimages/addMemberGuide5_Jap.png";

class CreateGroupGuide extends Component {
  componentWillMount() {
    //! FOR LANGUAGE SETTINGS
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }
  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    if (this.state.currentLanguage === "en") {
      return (
        <div
          style={{
            width: "90%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          {/* <img
            className="imgStyle"
            src={createGroupInstruction1}
            alt="createGroupInstruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%"
            }}
          />
          <img
            className="imgStyle"
            src={createGroupInstruction2}
            alt="createGroupInstruction2"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%"
            }}
          />
          <img
            className="imgStyle"
            src={createGroupInstruction3}
            alt="createGroupInstruction3"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%"
            }}
          />
          <img
            className="imgStyle"
            src={createGroupInstruction4}
            alt="createGroupInstruction4"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%"
            }}
          /> */}
        </div>
      );
    } else if (this.state.currentLanguage === "ja") {
      return (
        <div
          style={{
            width: "90%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          {/* <img
            className="imgStyle"
            src={createGroupInstruction1Jap}
            alt="createGroupInstruction1Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%"
            }}
          />
          <img
            className="imgStyle"
            src={createGroupInstruction2Jap}
            alt="createGroupInstruction2Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%"
            }}
          />
          <img
            className="imgStyle"
            src={createGroupInstruction3Jap}
            alt="createGroupInstruction3Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%"
            }}
          />
          <img
            className="imgStyle"
            src={createGroupInstruction4Jap}
            alt="createGroupInstruction4Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%"
            }}
          />

          <img
            className="imgStyle"
            src={createGroupInstruction5Jap}
            alt="createGroupInstruction5Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%"
            }}
          /> */}
        </div>
      );
    } else if (this.state.currentLanguage === "es") {
      return (
        <div
          style={{
            width: "90%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          {/* <img
            className="imgStyle"
            src={createGroupInstruction1}
            alt="createGroupInstruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%"
            }}
          />
          <img
            className="imgStyle"
            src={createGroupInstruction2}
            alt="createGroupInstruction2"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%"
            }}
          />
          <img
            className="imgStyle"
            src={createGroupInstruction3}
            alt="createGroupInstruction3"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%"
            }}
          />
          <img
            className="imgStyle"
            src={createGroupInstruction4}
            alt="createGroupInstruction4"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%"
            }}
          /> */}
        </div>
      );
    }
  }
}

export default CreateGroupGuide;
